import transactions from "../../ExecutiveDashboardViewAllData.json";

export type ExecutiveTransaction = (typeof transactions)[number];
export const overviewTransactions: ExecutiveTransaction[] = transactions;

export const overviewOptions = (key: keyof ExecutiveTransaction) =>
  Array.from(new Set(overviewTransactions.map((row) => String(row[key] ?? "")).filter(Boolean))).sort();

export function filterOverview(rows: ExecutiveTransaction[], filters: Record<string, string>) {
  return rows.filter((row) => {
    if (filters.geography && filters.geography !== "All Regions" && row.Geography !== filters.geography) return false;
    if (filters.businessUnit && filters.businessUnit !== "All BUs" && row.Business_Unit !== filters.businessUnit) return false;
    if (filters.category && filters.category !== "All Categories" && row.Category_L1 !== filters.category) return false;
    if (filters.supplier && filters.supplier !== "All Suppliers" && row.Supplier_Name_Normalized !== filters.supplier) return false;
    if (filters.directIndirect && filters.directIndirect !== "Both" && row.Direct_vs_Indirect !== filters.directIndirect) return false;
    if (filters.timeframe && filters.timeframe !== "Last 3 Years" && row.Year !== Number(filters.timeframe)) return false;
    if (filters.contractStatus && filters.contractStatus !== "ALL" && row.Contract_Status !== filters.contractStatus) return false;
    if (filters.tailSpend === "Exclude" && row.Tail_Spend_Flag === "Yes") return false;
    if (filters.confidence && filters.confidence !== "Any" && row.AI_Confidence_Score <= Number(filters.confidence.slice(1, -1)) / 100) return false;
    if (filters.spendRange === "$0-1M" && row.Spend_Amount_USD >= 1_000_000) return false;
    if (filters.spendRange === "$1M-10M" && (row.Spend_Amount_USD < 1_000_000 || row.Spend_Amount_USD >= 10_000_000)) return false;
    if (filters.spendRange === ">$10M" && row.Spend_Amount_USD < 10_000_000) return false;
    return true;
  });
}

export const total = (rows: ExecutiveTransaction[], key: "Spend_Amount_USD" | "Savings_Identified_USD" | "Budget_Amount_USD") =>
  rows.reduce((sum, row) => sum + row[key], 0);

export const usd = (value: number) => value >= 1_000_000
  ? `$${(value / 1_000_000).toFixed(1)}M`
  : value >= 1_000 ? `$${(value / 1_000).toFixed(1)}K` : `$${value.toFixed(0)}`;

export function groupCubeRows(rows: ExecutiveTransaction[], key: keyof ExecutiveTransaction | ((row: ExecutiveTransaction) => string)) {
  const groups = new Map<string, { label: string; amount: number; count: number; supplierIds: Set<string> }>();
  for (const row of rows) {
    const label = typeof key === "function" ? key(row) : String(row[key] ?? "Unclassified");
    const group = groups.get(label) || { label, amount: 0, count: 0, supplierIds: new Set<string>() };
    group.amount += row.Spend_Amount_USD;
    group.count += 1;
    group.supplierIds.add(row.Supplier_ID);
    groups.set(label, group);
  }
  return Array.from(groups.values(), ({ supplierIds, ...group }) => ({ ...group, suppliers: supplierIds.size }))
    .sort((first, second) => second.amount - first.amount);
}